var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13446",
    "data-name": "Group 13446",
    transform: "translate(-86 -399)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_791",
    "data-name": "Ellipse 791",
    cx: 58,
    cy: 58,
    r: 58,
    transform: "translate(86 399)",
    fill: "#170a33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check-broken",
    d: "M77.687,40.043A37.618,37.618,0,1,1,56.513,6.184M70.629,16.516,37.691,49.454,28.28,40.043",
    transform: "translate(103.548 417.125)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckImage);
export default __webpack_public_path__ + "static/media/check_image.49b75f81975d10b5bccb4e8d12998c55.svg";
export { ForwardRef as ReactComponent };